var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePay = function SvgGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.04 8.37v2.28h-.712V5.021h1.89a1.68 1.68 0 0 1 1.221.49c.646.61.686 1.638.08 2.298l-.08.08c-.332.32-.739.48-1.221.48H12.04Zm0-2.658v1.966h1.196a.925.925 0 0 0 .703-.291 1 1 0 0 0-.022-1.396.965.965 0 0 0-.681-.279H12.04ZM16.594 6.673c.527 0 .942.144 1.248.427.305.282.456.677.456 1.176v2.374h-.682v-.534h-.03c-.297.44-.687.66-1.178.66-.416 0-.77-.126-1.049-.377a1.198 1.198 0 0 1-.42-.943c0-.4.15-.713.447-.951.296-.238.695-.355 1.19-.355.425 0 .77.08 1.045.233v-.166a.85.85 0 0 0-.292-.642 1.027 1.027 0 0 0-.686-.264c-.399 0-.713.17-.943.511l-.628-.4c.336-.498.845-.749 1.522-.749Zm-.92 2.797c0 .188.088.363.234.471.16.126.354.193.553.189.301 0 .589-.122.801-.337.235-.225.354-.49.354-.795-.221-.18-.53-.269-.93-.264a1.22 1.22 0 0 0-.725.21c-.19.14-.287.315-.287.526Z",
    fill: "#3C4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.21 6.799-2.38 5.544h-.735l.885-1.94L18.418 6.8h.774l1.129 2.765h.013L21.436 6.8h.774Z",
    fill: "#3C4043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16 7.876c0-.22-.018-.44-.054-.655H6.102v1.243h1.721c-.07.4-.3.759-.637.983v.808h1.026c.602-.56.948-1.391.948-2.379Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.101 11.036c.859 0 1.585-.287 2.111-.78l-1.026-.809c-.288.198-.655.31-1.085.31-.832 0-1.535-.57-1.787-1.333H3.256v.835A3.178 3.178 0 0 0 6.1 11.036Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.314 8.424a1.977 1.977 0 0 1 0-1.24v-.83H3.256a3.246 3.246 0 0 0 0 2.9l1.058-.83Z",
    fill: "#FBBC04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.101 5.851c.456-.009.894.167 1.222.485l.911-.924a3.052 3.052 0 0 0-2.133-.84 3.182 3.182 0 0 0-2.845 1.782l1.058.835c.252-.767.955-1.338 1.787-1.338Z",
    fill: "#EA4335"
  })));
};
export default SvgGooglePay;